module.exports = __webpack_public_path__ + "static/media/coolblue.32c8177e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/coolblue.webp
// module id = 30
// module chunks = 0